import Heading from '@/common/shared/heading'
import { Separator } from '@/common/ui/separator'
import ManageMemberTable from '../ManageMemberTable'
import { Button } from '@/common/ui/button'
import { GetOperatorMemberListTableData } from '@/modules/manage-member/type'
import { Link } from 'react-router-dom'
import { PlusIcon } from 'lucide-react'
import useQueryProfile from '@/modules/auth/api/hooks/useQueryProfile'
import { PermissionKeys } from '@/modules/manage-member/mappers'

interface ManageMemberListingProps {
	data: GetOperatorMemberListTableData[]
	total: number
	isLoading?: boolean
}

export default function ManageMemberListing({
	data,
	total,
	isLoading,
}: ManageMemberListingProps) {
	const { data: user } = useQueryProfile()
	const hasWritePermission = user?.userGroup.writePermission.includes(
		PermissionKeys.MANAGE_OPERATOR,
	)
	return (
		<div className="space-y-4">
			<div className="flex items-start justify-between">
				<Heading
					title={`รายชื่อผู้ดูแลระบบทั้งหมด`}
					description="รายชื่อผู้ดูแลระบบทั้งหมด"
				/>
				{hasWritePermission && (
					<Button asChild variant="default">
						<Link to="/operator/manage-member/create-member">
							<PlusIcon className="h-4 w-4" />
							เพิ่มผู้ดูแลระบบ
						</Link>
					</Button>
				)}
			</div>
			<Separator />
			<ManageMemberTable data={data} total={total} isLoading={isLoading} />
		</div>
	)
}
